<template>
  <div class="OwnedCargo flex-jc-bt">
    <div class="flex-60 left-side">
      <SpCard class="card">
        <div class="flex-jc-bt">
          <div class="flex-75 text-left title">
            <p class="fs-bold">{{ $l('Pleasedefinethecompanieswhoinvolvedinthetradeconcernedthiscargo') }}</p>
            <p class="fs-int tip">{{ $l('Pleasefeelfreetodecideyouroneormultichoice') }}</p>
          </div>
          <SpButton class="flex-15" type="backStyle" width="158" height="77" circle>
            <SpRadio name="stop" :disabled="formData.ownershipStatus !== 1" :value="1"><div class="stop-button-label">{{ $l('Westoppedtradinginthisproduct') }}</div></SpRadio>
          </SpButton>
        </div>

        <div class="flex-al-start flex-jc-bt">
          <div v-for="(optionsBy, key) in groupByOptions" class="flex-49 text-left">
            <p class="op-title text-left">{{ key }}</p>
            <div v-for="(option,index) in optionsBy" :key="`options-${index}`" class="item">
              <SpRadio :name="`sovereignOwnerships.${_findIndex(options, (op) => op.id === option.id)}.typeId`" :disabled="!canOperated" :value="option.id"><span class="fs-int">{{ option.name }}</span></SpRadio>
              <SpSelect :name="`sovereignOwnerships.${_findIndex(options, (op) => op.id === option.id)}.corpIds`" :disabled="!canOperated" multi-select class="mg-t-10" :options="companies" type="warn" height="35" />
            </div>
          </div>
        </div>
        <div class="mg-t-20">
          <div class="flex-jc-center">
            <!--          <SpButton v-if="!canOperated" :label="$l('reclaimRight')" :width="400" :height="110" bold :circle-radius="1" @click="openOp" /> -->
            <SpButton class="mg-r-40" circle bold type="back" :width="240" :height="75">{{ $l('Back') }}</SpButton>
            <SpButton html-type="submit" circle bold :width="240" :height="75">{{ $l('Submit') }}</SpButton>
          </div>
        </div>
      </SpCard>
      <p class="card-tip none-style">{{ $l('TheabovecompaniesthatneedtobeselectedmustbeinitializedintheCompaniesandStaffControlpageinadvance') }}</p>
      <p class="card-tip none-style">{{ $l('Ifyoucantfindthecompanyyouneedherepleasesolveitasfollows') }}</p>
      <p class="card-tip">{{ $l('Method1informHRordesigneetofillintherequiredcompany') }}</p>
      <p class="card-tip">{{ $l('Method2addtherequiredcompanyintheCompanydefinitionpageonyourown') }}</p>
    </div>
    <div class="flex-38 right-side sp-color-bg-4 text-left">
      <p class="fs-bold mg-b-60">{{ $l('SomeSupportingFilesPicturesPDForOthers') }}</p>
      <p class="fs-int upload-title">{{ $l('CopyofLastBillofLadingInLastExperience') }}</p>
      <SpUploadGroup v-if="!canOperated" :default-files="cargoLadingFiles" :disabled="!canOperated" accept="image" />
      <SpUploadGroup v-else :default-files="cargoLadingFiles" :business-id="formData.businessId" file-type="ownership/sovereign/cargo/lading" accept="image" />
      <p class="fs-int upload-title">{{ $l('CopyofLetterofCreditinLastExperience') }}</p>
      <SpUploadGroup v-if="!canOperated" :default-files="cargoCreditFiles" :disabled="!canOperated" accept="image" />
      <SpUploadGroup v-else :business-id="formData.businessId" :default-files="cargoCreditFiles" file-type="ownership/sovereign/cargo/credit" accept="image" />
      <p class="fs-int upload-title">{{ $l('Others') }}</p>
      <SpUploadGroup v-if="!canOperated" :default-files="cargoOtherFiles" :disabled="!canOperated" accept="image" />
      <SpUploadGroup v-else :business-id="formData.businessId" :default-files="cargoOtherFiles" file-type="ownership/sovereign/cargo/other" accept="image" />
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import SpCard from '@/components/common/SpCard.vue'
import SpButton from '@/components/common/SpButton.vue'
import SpRadio from '@/components/common/SpRadio.vue'
import SpSelect from '@/components/common/SpSelect.vue'
import SpSelectOption from '@/components/common/SpSelectOption.vue'
import SpUploadGroup from '@/components/common/SpUploadGroup.vue'
import { computed, ref } from 'vue'
import { formatFiles } from '@/utils/convert'
import _groupBy from 'lodash/groupBy'
import _findIndex from 'lodash/findIndex'
export default {
  name: 'OwnedCargo',

  nameSpace: 'cargoOwner.cargo.RightClaim.OwnedCargoVUE',

  components: {
    SpCard,
    SpButton,
    SpRadio,
    SpSelect,
    SpSelectOption,
    SpUploadGroup
  },

  props: {
    canOperated: {
      type: Boolean,
      default: false
    },

    options: {
      type: Array,
      default: () => []
    },

    companies: {
      type: Array,
      default: () => []
    },

    formData: {
      type: Object,
      default: () => ({})
    }
  },

  emits: ['openOp'],

  setup (props, ctx) {
    const cargoLadingFiles = computed(() => {
      let files = []
      if (props.formData?.ownership?.ladingFiles) {
        files = formatFiles(props.formData?.ownership, 'ladingFiles')
      }
      return files
    })
    const cargoCreditFiles = computed(() => {
      let files = []
      if (props.formData?.ownership?.creditFiles) {
        files = formatFiles(props.formData?.ownership, 'creditFiles')
      }
      return files
    })
    const cargoOtherFiles = computed(() => {
      let files = []
      if (props.formData?.ownership?.otherOwnershipFiles) {
        files = formatFiles(props.formData?.ownership, 'otherOwnershipFiles')
      }
      return files
    })
    const groupByOptions = computed(() => {
      return _groupBy(props.options, 'value')
    })
    const openOp = () => {
      ctx.emit('openOp')
    }
    return {
      cargoLadingFiles,
      cargoCreditFiles,
      cargoOtherFiles,
      openOp,
      groupByOptions,
      _findIndex
    }
  }
}
</script>

<style scoped lang="less">
.OwnedCargo{
  .op-title{
    display: inline-block;
    padding: 4px 20px;
    //float: left;
    background-color: #E5E5E5;
  }
  padding: @gap 0;
  .left-side{
    .card{
      .title{
        p{
          margin:0;
        }
        .tip{
          opacity: 0.6;
          font-size: 14px;
          padding-top: @gap/4;
        }
      }
      .item{
        text-align: left;
        margin-top: @gap/2;
      }
    }
    .card-tip{
      text-align: left;
      text-indent: 2em;
      font-size: 14px;
      font-family: Arial;
      font-weight: 400;
      color: #000000;
      opacity: 0.5;
    }
    .none-style{
      margin:0;
    }
    .buttons{
      margin-top: @gap*3;
      width:60%;
    }
    .stop-button-label{
      white-space: pre-wrap;
    }
  }
  .right-side{
    box-sizing: border-box;
    padding: @gap;
    .upload-title{
      opacity: 0.6;
      margin-top: @gap;
    }
  }
}
</style>
